import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers/index';
import idleChecker from './middlewares/idle-checker';

export default createStore(
	reducers,
	applyMiddleware(
		idleChecker,
		thunk
	)
);



// WEBPACK FOOTER //
// ./src/client/redux/store.js